// src/modules/app-views/products/pages/Document/components/ProductsDocumentCardHeaderColumn2.jsx
// *******************************************************************************
// CARD HEADER COLUMN 2 - Cost / Markup / Price (Margin)
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import SimpleColumn from 'components/SimpleComponents/SimpleColumn';
import { DollarOutlined, PercentageOutlined, TagOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';
import financialService from 'services/financialService';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
export const ProductsDocumentCardHeaderColumn2 = ({ ...record }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const suppliers = record?.suppliers || [];
  const primarySupplier = suppliers.find(s => s.isPrimary && s.isActive !== false)
    || suppliers.find(s => s.isActive !== false)
    || suppliers[0];

  const costPrice = record?.pricing?.costPrice || primarySupplier?.convertedUnitCost || 0;
  const markup = record?.pricing?.markup || 0;
  const salePrice = record?.price || 0;

  // Margin = (price - cost) / price × 100
  const margin = costPrice > 0 && salePrice > 0
    ? financialService.calculateMargin(costPrice, salePrice, 3)
    : 0;

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────
  const items = [
    {
      key: 'costPrice',
      icon: <DollarOutlined />,
      label: costPrice > 0 ? financialService.formatCurrency(costPrice) : '—',
      tooltipText: translateX('unit_cost'),
      tooltipPlacement: 'right',
    },
    {
      key: 'markup',
      icon: <PercentageOutlined />,
      label: `${financialService.formatNumber(markup, { decimals: 3 })}%`,
      tooltipText: 'Markup',
      tooltipPlacement: 'right',
    },
    {
      key: 'salePrice',
      icon: <TagOutlined />,
      label: salePrice > 0
        ? `${financialService.formatCurrency(salePrice)} (${financialService.formatNumber(margin, { decimals: 3 })}%)`
        : '—',
      tooltipText: `${translateX('sale_price')} (${translateX('margin')})`,
      tooltipPlacement: 'right',
    },
  ];

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return <SimpleColumn items={items} />;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default ProductsDocumentCardHeaderColumn2;
